
import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import commonServices from '@/services/common-services';
@Component
export default class RechargeInfo extends Vue {
    @Prop({ default: 0 })
    private money!: number;
    private bankInfos: any = [];
    private bankInfo = {
        'BankName': '',
        'BankCode': '',
        'Owner': '',
        'CardNumber': ''
    }
    get rechargeMethods() {
        return DATA.rechargeMethods;
    }
    get qrLink() {
        // return `https://api.vietqr.io/image/${this.bankInfo.BankCode}-${this.bankInfo.CardNumber}-X1lAHCn.jpg?addInfo=TMDT${this.userInfo.userId}&accountName=${this.bankInfo.Owner}&amount=${this.money}`;
        return `https://api.vietqr.io/image/${this.bankInfo.BankCode}-${this.bankInfo.CardNumber}-X1lAHCn.jpg?accountName=${this.bankInfo.Owner}&amount=${this.money}`;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get currentTime() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = String(now.getFullYear()).slice(-2); // Get last two digits of the year
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return `${day}${month}${year}${hours}${minutes}`; // Format: DDMMYYHHmm
    }

    private async created() {
        const result = await commonServices.getBankInfo();
        if (
        result &&
        result.status === 200 &&
        result.data.message === 'Success'
        ) {
        this.bankInfos = result.data.data;
        if (this.bankInfos.length > 0) {
            this.bankInfo = this.bankInfos[0];
        }
        }
    }
}

